import { Interpolation, Theme } from '@emotion/react';
import { Theme as MuiTheme } from '@mui/material';
import { WheelEvent } from 'react';
import { defaultTheme } from 'react-admin';
import { colours } from './colourPalette';

export type StyleObject = { [key: string]: Interpolation<Theme> };
export type StyleObjectWithTheme = (theme: ThemeConfig) => StyleObject;
export type ThemeConfig = typeof theme & MuiTheme;

export const theme = {
  ...defaultTheme,
  typography: {
    fontSize: 12,
    // @ts-ignore
    fontWeight: ['400', '600', '700'],
    fontFamily: [
      '"Open Sans"',
      '-apple-system',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  components: {
    MuiModal: {
      defaultProps: {
        disableEnforceFocus: true,
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          '&.RaShow-card': {
            paddingBottom: '0.5rem',
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'filled' as const,
        margin: 'dense' as const,
        size: 'small' as const,
      },
    },
    MuiFormControl: {
      defaultProps: {
        variant: 'filled' as const,
        margin: 'dense' as const,
        size: 'small' as const,
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          border: '1px solid #D4E1EC',
          boxShadow: 'inherit',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&.MuiTableRow-hover:hover': {
            backgroundColor: '#f2f7fa',
          },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        toolbar: {
          paddingBottom: '50px',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderColor: '#D4E1EC',
        },
      },
    },
    MuiInputBase: {
      defaultProps: {
        onWheel: (e: WheelEvent<HTMLInputElement>) =>
          (e.target as HTMLElement).blur(),
      },
    },
  },
  palette: {
    primary: {
      light: colours.tropicalBlue,
      main: colours.pictonBlue, // Save Button + ADD GROUP
      dark: colours.lapisLuzuli, // Hover Save Button
      contrastText: colours.white, // Content Save Button Text
    },
    secondary: {
      main: colours.lapisLuzuli, // Title Bar Background
      dark: colours.prussianBlue,
      contrastText: colours.white, // Title Bar Text Colour
    },
    error: {
      light: colours.lightCoral,
      main: colours.folly, // Content Archive Button/Delete Button
      dark: colours.persianRed,
      contrastText: colours.white,
    },
    background: {
      default: colours.backgroundLight, // Main Background colour (All)
      info: colours.warningYellow,
    },
    text: {
      primary: colours.textDark, // Field Text (Descriptions etc)
      secondary: colours.textGrey, // Helper text
      info: colours.darkYellow,
    },
    border: {
      default: colours.borderGrey,
      light: colours.borderLightGrey,
    },
  },
};

export const wllTheme = theme;
